export default function percentageFormat(value) {
    return `${value}%`;
}
